import React, {useEffect} from 'react'
import {Grid, Tabs, Tab} from '@mui/material'
import useCustomerData from '../../hooks/useCustomerData'
import {CUSTOMER_TYPE} from '../../utils/constants'
import WbTextField from '../../components/common/WbTextField'
import MenuItem from '@mui/material/MenuItem'
import {useIdentityAuth} from '../../auth/IdentityAuthHook'
import {getApiHookParams} from '../../auth'

export default function DashboardTabs({
  view,
  setView,
  schoolList,
  selectedSchool,
  setSelectedSchool,
}) {
  const customer = useCustomerData()
  const [tabs, setTabs] = React.useState([])
  const [showSchools, setShowSchools] = React.useState(false)

  const {user, authenticated, authLoading} = useIdentityAuth()
  const apiParams = getApiHookParams()

  useEffect(() => {
    if (apiParams.groupId > 0 && apiParams.schoolId === null) {
      setShowSchools(true)
      setTabs([
        {value: 0, label: 'Trust Surveys'},
        {value: 1, label: 'School Surveys'},
      ])
    } else {
      setTabs([
        {value: 0, label: 'School Surveys'},
        {value: 1, label: 'Trust Surveys'},
      ])
    }
  }, [])
  return (
    <div className="dashboard-tabs">
      <Grid container>
        <Grid item lg={9} md={9} sm={12} xs={12}>
          <Tabs value={view} onChange={(e, newValue) => setView(newValue)}>
            {tabs.map(tab => (
              <Tab key={tab.value} label={tab.label} />
            ))}
          </Tabs>
        </Grid>

        <Grid item lg={3} md={3} sm={12} xs={12}>
          {showSchools && view === 1 && (
            <WbTextField
              select
              label="Select School"
              value={selectedSchool}
              onChange={e => setSelectedSchool(e.target.value)}
            >
              <MenuItem value={-1}>{'All Schools'}</MenuItem>
              {schoolList
                .filter(school => 
                  // Filter schools to only show those from apiParams.schoolIds
                  !apiParams.schoolIds || 
                  apiParams.schoolIds.length === 0 || 
                  apiParams.schoolIds.includes(school.id)
                )
                .map(school => (
                  <MenuItem key={school.id} value={school.id}>
                    {school.name}
                  </MenuItem>
                ))}
            </WbTextField>
          )}
        </Grid>
      </Grid>
    </div>
  )
}
